<template>
  <div class="accodion_box_cont payment-other">
    <div class="payment_selte">
      <div class="payTab v2">
        <input
          type="radio"
          class="amwa-radio"
          id="payment-other"
          :checked="otherPayOn"
          @change="toggleRadio($event)"
        >
        <label for="payment-other">다른 결제수단 <span>(자동이체, 신용카드)</span></label>
        <div class="payTab_button_area" :style="styleOtherPayMethodDisplay">
          <a class="payTaba payTab2" :class="classAccount" @click="selectOtherPayAccount">
            자동이체
          </a>
          <a class="payTaba payTab4" :class="classCreditCard" @click="selectOtherPayCard">
            신용카드
          </a>
        </div>
        <div class="payTab_cont_area radio-type1">
          <!-- 자동이체 -->
          <direct-debit v-show="displayOtherPaymentAccount" />
          <!-- 신용카드(빌링키) -->
          <credit-card-billing v-show="displayOtherPaymentCreditCard" @save-data="$emit('save-data')" />
        </div>
      </div>
    </div>
    <modal-alert ref="refAlert" />
  </div>
</template>

<script>
import { AMWAY_PAY_METHODS, NORMAL_PAYMENT_METHODS, PAYMENT_METHODS } from "@/utils/constants";
import DirectDebit from '@/views/composition/payment/DirectDebit.vue';
import CreditCardBilling from '@/views/composition/payment/CreditCardBilling.vue';
import ModalAlert from "@/components/global/ModalAlert";

export default {
  name: "OtherPay",
  components: {
    DirectDebit,
    CreditCardBilling,
    ModalAlert,
  },
  methods: {
    toggleRadio(event) {
      let checked = event.target.value;
      this.$emit("toggle-other-pay", checked);
    },
    selectOtherPayAccount() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.NORMAL,
        selectedOtherPayMethod: NORMAL_PAYMENT_METHODS.TRANSFER,
      });
    },
    selectOtherPayCard() {
      this.$emit("update-payment-info", {
        selectedPaymentMethod: PAYMENT_METHODS.NORMAL,
        selectedOtherPayMethod: NORMAL_PAYMENT_METHODS.CREDIT_CARD,
      });
    },
    toggleAccordion() {
      this.accordionCollapsed = !this.accordionCollapsed;
    },
  },
  computed: {
    classAccount() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER && this.otherPayOn
        ? "on" : "";
    },
    classCreditCard() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD && this.otherPayOn
        ? "on": "";
    },
    displayOtherPaymentCreditCard() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.CREDIT_CARD && this.otherPayOn;
    },
    displayOtherPaymentAccount() {
      return this.selectedOtherPayMethod === NORMAL_PAYMENT_METHODS.TRANSFER && this.otherPayOn;
    },
    styleOtherPayMethodDisplay() {
      return this.otherPayOn ? { display: "block" } : { display: "none" };
    },
    otherPayOn() {
      return this.paymentMethodInfo.paymentMethod === PAYMENT_METHODS.NORMAL;
    },
    selectedOtherPayMethod() {
      return this.paymentMethodInfo.otherPaymentMethod;
    },
    classCollapsed() {
      return this.accordionCollapsed ? "collapsed" : "";
    },
    classAccountInfoIn() {
      return !this.accordionCollapsed ? "in" : "";
    }
  },
  props: {
    paymentMethodInfo: {
      type: Object,
      required: true,
      default: () => {
        return {
          paymentMethod: PAYMENT_METHODS.NORMAL,
          otherPaymentMethod: NORMAL_PAYMENT_METHODS.TRANSFER,
          amwayPayMethod: AMWAY_PAY_METHODS.ACCOUNT,
        }
      }
    },
    canInstalling: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>

</style>
